var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"49%","box-sizing":"border-box"}},[_c('div',{staticClass:"p_l_20"},[_c('span',[_vm._v(_vm._s(_vm.$lang('N00904', '~风速~')))])]),_c('div',{staticStyle:{"margin-top":"20px"},style:({ height: '35vh'}),attrs:{"id":"main"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }